import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SpecialProjectStatusEnum } from '../../pages/specialProject/interface';
import { CoreStatus, JobCoreStatus } from '../CoreStatus';

interface ISpecialProjectStatus {
  value: SpecialProjectStatusEnum;
}

const SpecialProjectStatusColor = {
  [SpecialProjectStatusEnum.InProduction]: '#06B6D4',
  [SpecialProjectStatusEnum.Ready]: '#D19500',
  [SpecialProjectStatusEnum.RequiredBooking]: '#EC4899',
  [SpecialProjectStatusEnum.DeliveryBooked]: '#3B82F6',
  [SpecialProjectStatusEnum.Delivered]: '#22C55E',
  [SpecialProjectStatusEnum.Completed]: '#22C55E',
  [SpecialProjectStatusEnum.OnHold]: '#A855F7',
  [SpecialProjectStatusEnum.Exception]: '#DC2626',
  [SpecialProjectStatusEnum.Canceled]: '#83664B',
};
export const SpecialProjectStatus: FC<ISpecialProjectStatus> = ({ value }) => {
  const { t } = useTranslation('status', { keyPrefix: 'specialProjectList' });

  return (
    <CoreStatus
      value={t(value, value)}
      backgroundColor={SpecialProjectStatusColor[value]}
    />
  );
};

export const JobStatus: FC<ISpecialProjectStatus> = ({ value }) => {
  const { t } = useTranslation('status', { keyPrefix: 'specialProjectList' });
  return (
    <JobCoreStatus
      value={t(value, value)}
      backgroundColor={SpecialProjectStatusColor[value]}
    />
  );
};
